export const ISSUE_TYPES = Object.freeze([
  { label: "Payment & Account Issues", value: "16" },
  { label: "IT Support", value: "14" },
  { label: "Feedback", value: "17" },
  { label: "AFTL NG", value: "18" },
  { label: "Trade", value: "19" },
  { label: "Exchange", value: "20" },
  { label: "Banking", value: "21" },
  { label: "Data", value: "22" },
  { label: "General", value: "15" },
]);

export type IssueTypeValue = (typeof ISSUE_TYPES)[number]["label"];
